import React from 'react'
import {Container} from 'react-bootstrap';
import imports from '../assets/imports.png';
import exports from '../assets/export.png';
import { Link } from 'react-router-dom';
import cbic_logo from '../assets/logo_new.png';

const Home = () => {
  return (
     <div className="mt-4">
        <div className="who-we-are">
          <div className="container">
            <div className="app-title">
              <img
            className="d-block mx-auto"
            src={cbic_logo}
            alt="CBIC" width={100} height={100} loading='lazy'
          />
              <h4>Welcome to ECCS</h4>
              <div className="line"></div>
            </div>
          </div>
        </div>

        <div className='service app-section app-bg-dark mt-4'>
        <Container>
          <div className="app-title mt-4">
            <h4>ECCS Public Enquiry Portal</h4>
            <div className="line"></div>
          </div>

          <div className="row justify-content-center">
            {/* Card 1 */}
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                    <Link to="/import" className="text-decoration-none text-dark">
                        <img
                            className="mx-auto service-image cursor-pointer"
                            src={imports}
                            alt="import" loading='lazy'
                        />
                        <div className="card-body">
                        <h5 className="card-title cursor-pointer">Present Status of Import Shipment</h5>
                        </div>
                    </Link>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                  <Link to="/export" className="text-decoration-none text-dark">
                  <img
                  className="mx-auto service-image cursor-pointer"
                  src={imports}
                  alt="import" loading='lazy'
                />
                <div className="card-body">
                  <h5 className="card-title cursor-pointer">Present Status of Export Shipment</h5>
                </div>
                  </Link>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                  <Link to="/cbetoidpms" className="text-decoration-none text-dark">
                  <img
                  className="mx-auto service-image cursor-pointer"
                  src={exports}
                  alt="import" loading='lazy'
                />
                <div className="card-body">
                  <h5 className="card-title cursor-pointer">Status of Transmission of CBE to RBI-IDPMS</h5>
                </div>
                  </Link>
              </div>
            </div>

            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                <Link to="/csbtoedpms" className="text-decoration-none text-dark">
                 <img
                  className="mx-auto service-image cursor-pointer"
                  src={exports}
                  alt="import" loading='lazy'
                />
                <div className="card-body">
                  <h5 className="card-title cursor-pointer">Status of Transmission of CSB to RBI-EDPMS</h5>
                </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                <a href="https://enquiry.icegate.gov.in/BE_HelpDesk_View/getInsertBEDetailsPage" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                <img
                  className="mx-auto service-image cursor-pointer"
                  src={exports}
                  alt="import" loading='lazy'
                />
                <div className="card-body">
                  <h5 className="card-title cursor-pointer">Status of CBE Transmission to GSTIN</h5>
                </div>
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="card custom-card shadow text-center p-2 border-0">
                <a href="https://enquiry.icegate.gov.in/enquiryatices/manual-sb-input" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                  <img
                  className="mx-auto service-image cursor-pointer"
                  src={exports}
                  alt="import" loading='lazy'
                />
                <div className="card-body">
                  <h5 className="card-title cursor-pointer">Status of CSBs Transmission to ICEGATE</h5>
                </div>
                </a>
              </div>
            </div>
          </div>
        </Container>
        </div>
      </div>
  )
}
export default Home
